export default __webpack_public_path__ + "static/media/close.98803b83.svg";